import { createI18n } from 'vue-i18n'
import { enUS, deDE } from './locale'

// Create VueI18n instance with options
// legacy: true preserves $t() Options API usage throughout all components
export const i18n = createI18n({
  locale: 'de_DE',
  legacy: true,
  messages: {
    de_DE: deDE,
    en_US: enUS
  }
})
